"use strict";

exports.__esModule = true;
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}

module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-overlays/~/dom-helpers/util/camelize.js
 ** module id = ./node_modules/react-overlays/node_modules/dom-helpers/util/camelize.js
 ** module chunks = 0
 **/